// Standalone product galleries are independent of bundle purchase controls.
(() => {
  document.querySelectorAll('[data-simple-product-gallery]').forEach(gallery => {
    const slides = [...gallery.querySelectorAll('[data-product-slide]')];
    const dots = [...gallery.querySelectorAll('[data-gallery-dot]')];
    const label = gallery.querySelector('[data-gallery-current]');
    if (!slides.length) return;
    let current = 0;
    const show = index => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === current);
        slide.setAttribute('aria-hidden', String(i !== current));
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === current);
        dot.setAttribute('aria-pressed', String(i === current));
      });
      if (label) label.textContent = String(current + 1);
    };
    dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(current - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(current + 1));
    gallery.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      show(current + (event.key === 'ArrowRight' ? 1 : -1));
    });
    show(0);
  });
})();

(() => {
  const root = document.querySelector('[data-tivelune-bundle]');
  if (!root) return;
  const cards = [...root.querySelectorAll('[data-bundle]')];
  const form = root.querySelector('[data-bundle-form]');
  const selectors = root.querySelector('[data-age-selectors]');
  const saving = root.querySelector('[data-saving]');
  const total = root.querySelector('[data-total]');
  const stickyTotal = root.querySelector('[data-sticky-total]');
  const variant = root.querySelector('[data-bundle-variant]');
  const gallery = root.querySelector('[data-product-gallery]');
  let showGallerySlide = () => {};
  const singleVariants = JSON.parse(root.querySelector('[data-single-variants]').textContent);
  const ages = singleVariants.map(v => v.age);
  const currency = root.dataset.currency || 'EUR';
  const money = value => Number(value).toLocaleString(currency === 'USD' ? 'en-US' : 'de-DE', { style: 'currency', currency });
  const savingBox = root.querySelector('[data-saving-box]');
  const submit = form.querySelector('[type="submit"]');
  const sticky = root.querySelector('[data-sticky-add]');
  const singleCard = cards.find(card => card.dataset.bundle === '1');
  let count = 1, selectedCard = singleCard;
  const remembered = [ages[0], ages[0], ages[0]];
  const preferredAge = { '1-3': ages[0], '3-8': ages[1], '8-12': ages[2], '8-14': ages[2] }[new URLSearchParams(location.search).get('age')];
  const firstAvailable = singleVariants.find(v => v.id && v.available);
  remembered[0] = preferredAge || firstAvailable?.age || ages[0];
  if (singleCard) singleCard.disabled = !firstAvailable;
  function update() {
    const chosen = singleVariants.find(v => v.age === selectors.querySelector('select')?.value);
    const model = count === 1 ? chosen : {id:selectedCard?.dataset.variant,price:Number(selectedCard?.dataset.price),compare:Number(selectedCard?.dataset.compare),available:!selectedCard?.disabled};
    const valid = Boolean(model?.id && model.available && Number.isFinite(Number(model.price)) && [...selectors.querySelectorAll('select')].every(s => s.value));
    variant.value = valid ? model.id : '';
    if (submit) submit.disabled = !valid;
    if (sticky) sticky.disabled = !valid;
    const price = Number(model?.price || 0), compare = Number(model?.compare || 0);
    const priceLabel = valid ? money(price) : 'Nicht verfügbar';
    total.textContent = priceLabel;
    if (stickyTotal) stickyTotal.textContent = priceLabel;
    if (count === 1 && singleCard) {
      singleCard.querySelector('[data-card-price]').textContent = priceLabel;
      singleCard.dataset.variant = model?.id || '';
      singleCard.dataset.price = price;
      singleCard.dataset.compare = compare;
      const oldPrice = singleCard.querySelector('[data-card-compare]');
      oldPrice.hidden = !valid || compare <= price;
      oldPrice.textContent = compare > price ? money(compare) : '';
    }
    const discount = valid ? Math.max(0, compare - price) : 0;
    saving.textContent = money(discount);
    savingBox.hidden = discount <= 0;
  }
  function renderFields() {
    selectors.replaceChildren(...Array.from({length:count},(_,i)=>{
      const label=document.createElement('label');label.append(`Alter von Kind ${i+1}`);
      const select=document.createElement('select');select.name=`properties[Kissen ${i+1} · Alter]`;select.required=true;
      ages.forEach(age=>{const option=document.createElement('option');option.value=age;option.textContent=age;const v=singleVariants.find(v=>v.age===age);option.disabled=!v?.id || (count===1&&!v.available);select.append(option)});
      select.value=remembered[i];
      if(!select.value)select.value=[...select.options].find(o=>!o.disabled)?.value || '';
      select.addEventListener('change',()=>{remembered[i]=select.value;update()});label.append(select);return label;
    }));
    update();
  }
  cards.forEach(card=>card.addEventListener('click',()=>{
    if(card.disabled)return;
    selectedCard=card;count=Number(card.dataset.bundle);
    cards.forEach(c=>{c.classList.toggle('is-selected',c===card);c.setAttribute('aria-checked',String(c===card))});
    renderFields();
  }));
  form.addEventListener('submit',event=>{update();if(!variant.value){event.preventDefault();alert('Bitte wähle eine verfügbare Variante.')}});
  sticky?.addEventListener('click',()=>form.requestSubmit());
  renderFields();

  if (gallery) {
    const slides = [...gallery.querySelectorAll('[data-product-slide]')];
    const dots = [...gallery.querySelectorAll('[data-gallery-dot]')];
    const currentLabel = gallery.querySelector('[data-gallery-current]');
    let current = 0;
    const show = index => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === current;
        const wasActive = slide.classList.contains('is-active');
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
        if (!active) {
          slide.querySelectorAll('video').forEach(video => video.pause());
          // Reload only the departing external player to stop audio reliably.
          if (wasActive) slide.querySelectorAll('iframe').forEach(frame => {
            const src = frame.getAttribute('src');
            if (src) frame.setAttribute('src', src);
          });
        }
      });
      dots.forEach((dot, i) => { dot.classList.toggle('is-active', i === current); dot.setAttribute('aria-pressed', String(i === current)); });
      if (currentLabel) currentLabel.textContent = String(current + 1);
    };
    showGallerySlide = show;
    dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(current - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(current + 1));
    const selectedCard = cards.find(card => card.classList.contains('is-selected'));
    if (root.dataset.curatedGallery !== 'true' && selectedCard?.dataset.imageIndex) show(Number(selectedCard.dataset.imageIndex));
    show(0);
    const hasPlayableMedia = slides.some(slide => slide.dataset.mediaType && slide.dataset.mediaType !== 'image');
    if (slides.length > 1 && !hasPlayableMedia && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let timer = null;
      gallery.addEventListener('mouseenter', () => clearInterval(timer));
      gallery.addEventListener('mouseleave', () => clearInterval(timer));
    }
  }
})();
